// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  TaxReturnsV2,
} from "./types";

export const params = {
  underwritableEntity: __t.uuid(),
  objectPath: __t.string(),
  taxYear: __t.i16(),
  originalFileName: __t.string(),
};
export const returnType = TaxReturnsV2